"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var time_1 = require("../../../common/helpers/time");
var LeadsController = /** @class */ (function () {
    function LeadsController(LeadsModel, FlashService, CreateStudentService, $state) {
        var _this = this;
        this.loading = true;
        this.submitting = false;
        this.currentPage = 0;
        this.LeadsModel = LeadsModel;
        this.leads = [];
        this.patch = this.patch.bind(this);
        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.submit = this.submit.bind(this);
        this.handleError = this.handleError.bind(this);
        this.FlashService = FlashService;
        this.CreateStudentService = CreateStudentService;
        this.$state = $state;
        this.leadsFilter = { status: "open" };
        this.lead = {}; //used for create lead form
        this.editLead = {}; //used for edit lead form
        this.modalShown = false;
        LeadsModel.get(this.leadsFilter).then(function (response) {
            _this.leads = response.leads.data.filter(function (lead) {
                lead.created_at = (0, time_1.formatDateTime)(new Date(lead.created_at), "MM/DD/YYYY h:mm A");
                return lead;
            });
            _this.loading = false;
            _this.totalItems = response.leads.total;
        });
    }
    LeadsController.prototype.filterBy = function (status) {
        if (status === void 0) { status = "open"; }
        this.leadsFilter.status = status;
        this.getLeads();
    };
    LeadsController.prototype.createStudent = function (lead) {
        var student = {
            firstname: lead.firstname,
            lastname: lead.lastname,
            phone: lead.phone,
            email: lead.email,
        };
        this.CreateStudentService.set("student", student);
        this.$state.go("drivecoach.admin.students.create");
    };
    LeadsController.prototype.handleError = function (error) {
        this.submitting = false;
    };
    LeadsController.prototype.getLeads = function () {
        var _this = this;
        var params = Object.assign({}, this.leadsFilter);
        if (this.currentPage > 1) {
            params.page = this.currentPage;
        }
        this.LeadsModel.get(params)
            .then(function (response) {
            _this.leads = response.leads.data.filter(_this.formatLead);
            _this.submitting = false;
        })
            .catch(this.handleError);
    };
    LeadsController.prototype.archiveLead = function (lead) {
        var _this = this;
        this.submitting = true;
        lead.status = "archived";
        this.LeadsModel.update(lead)
            .then(function (response) {
            _this.FlashService.setMessage({
                type: "success",
                message: response.message,
            });
            _this.getLeads();
        })
            .catch(this.handleError);
    };
    LeadsController.prototype.deleteLead = function (lead) {
        var _this = this;
        this.submitting = true;
        this.LeadsModel.delete(lead)
            .then(function (response) {
            _this.FlashService.setMessage({
                type: "success",
                message: response.message,
            });
            _this.getLeads();
        })
            .catch(this.handleError);
    };
    LeadsController.prototype.formatLead = function (lead) {
        lead.created_at = (0, time_1.formatDateTime)(new Date(lead.created_at), "MM/DD/YYYY h:mm A");
        return lead;
    };
    LeadsController.prototype.createLead = function () {
        var _this = this;
        this.submitting = true;
        this.LeadsModel.create(this.lead)
            .then(function (response) {
            _this.FlashService.setMessage({
                type: "success",
                message: response.message,
            });
            _this.getLeads();
            _this.lead = {};
        })
            .catch(this.handleError);
    };
    LeadsController.prototype.patch = function (updatedLead) {
        var leads = this.leads.map(function (lead) {
            if (lead.id === updatedLead.id) {
                return updatedLead;
            }
            return lead;
        });
        this.leads = leads;
    };
    LeadsController.prototype.pageChanged = function () {
        var _this = this;
        this.submitting = true;
        var params = __assign({ page: this.currentPage }, this.leadsFilter);
        this.LeadsModel.get(params).then(function (response) {
            _this.leads = response.leads.data.filter(_this.formatLead);
            _this.submitting = false;
        });
    };
    LeadsController.prototype.openModal = function (lead) {
        this.editLead = structuredClone(lead);
        this.modalShown = true;
    };
    LeadsController.prototype.closeModal = function () {
        this.modalShown = false;
        this.editLead = {}; //reset
    };
    LeadsController.prototype.submit = function (lead) {
        var _this = this;
        //submit for edit lead modal
        this.submitting = true;
        this.LeadsModel.update(lead)
            .then(function (response) {
            _this.FlashService.setMessage({
                type: "success",
                message: response.message,
            });
            //following 3 lines update leads with edited lead
            _this.patch(lead);
            _this.getLeads();
            _this.editLead = {}; //reset
            _this.modalShown = false;
        })
            .catch(function (error) { });
    };
    return LeadsController;
}());
LeadsController.$inject = [
    "LeadsModel",
    "FlashService",
    "CreateStudentService",
    "$state",
];
exports.default = LeadsController;
